import React from "react";

function TickIcon2() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="19"
      viewBox="0 0 18 19"
      fill="none"
    >
      <g clip-path="url(#clip0_2364_6749)">
        <path
          d="M9 18.25C11.3869 18.25 13.6761 17.3018 15.364 15.614C17.0518 13.9261 18 11.6369 18 9.25C18 6.86305 17.0518 4.57387 15.364 2.88604C13.6761 1.19821 11.3869 0.25 9 0.25C6.61305 0.25 4.32387 1.19821 2.63604 2.88604C0.948212 4.57387 0 6.86305 0 9.25C0 11.6369 0.948212 13.9261 2.63604 15.614C4.32387 17.3018 6.61305 18.25 9 18.25ZM12.9727 7.59766L8.47266 12.0977C8.14219 12.4281 7.60781 12.4281 7.28086 12.0977L5.03086 9.84766C4.70039 9.51719 4.70039 8.98281 5.03086 8.65586C5.36133 8.32891 5.8957 8.32539 6.22266 8.65586L7.875 10.3082L11.7773 6.40234C12.1078 6.07188 12.6422 6.07188 12.9691 6.40234C13.2961 6.73281 13.2996 7.26719 12.9691 7.59414L12.9727 7.59766Z"
          fill="#16A34A"
        />
      </g>
      <defs>
        <clipPath id="clip0_2364_6749">
          <path d="M0 0.25H18V18.25H0V0.25Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default TickIcon2;
